import React, {useContext,useEffect,useState} from 'react'
import {Card, CardHeader, CardActions, CardContent,Typography, Button, Alert, Box,Grid,CardMedia} from '@mui/material'
import { useNavigate } from 'react-router-dom';
import EventIcon from '@mui/icons-material/Event';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { formularioContext } from '../contextos/FormularioContext'
import {useHelper} from '../hooks/useHelper';

export const ETVisualizarEventos = ({eventos,eventoDefault,esModoTest})=>{

    const [eventoSeleccionado,seleccionarEvento]=useState(null)
    const navigate = useNavigate()
    const {validarTokenMinistro} = useContext(formularioContext)
    const {getToken} = useHelper();
    
    useEffect(()=>{
        if(eventoDefault){
            seleccionarEvento(eventoDefault)
        }
    },[eventoDefault])

    useEffect(async ()=>{

        let ruta = `/evento/${eventoSeleccionado}/all`;
        if(eventoSeleccionado){
            const tokenmin = getToken();

            if(tokenmin){
                const tokenvalido = await validarTokenMinistro(tokenmin);
                if(tokenvalido){
                    ruta = `/evento/${eventoSeleccionado}/uad`;
                }
            }
         navigate(ruta)

        }
    },[eventoSeleccionado])



if(eventos.length==0){
    return <Box sx={{ p: { xs: 2, md: 8 }, backgroundColor: 'white', width: '100%' }}>
            <Typography sx={{color:'firebrick',fontWeight:500}} variant="h5">No hay eventos habilitados en este momento</Typography>
    </Box>
}

return <Box sx={{ p: { xs: 2, md: 8 }, backgroundColor: 'white', width: '100%' }}>
  <Grid
    container
    spacing={2}
    justifyContent={eventos.length === 1 ? 'center' : 'flex-start'}
  >
    {eventos.map((item) => (
      <Grid
        item
        xs={12}
        md={eventos.length === 1 ? 6 : 6} // si es uno, usa ancho de 6 y centrado
        key={item.id}
      >
        <Box
          sx={{
            borderRadius: 2,
            overflow: 'hidden',
            boxShadow: 2,
            width: '100%',
          }}
        >
          <Box
            sx={{
              width: '100%',
              p: 2,
              aspectRatio: eventos.length === 1 ? '16 / 9' : '2 / 1',
              overflow: 'hidden',
              position: 'relative',
              '&:hover .overlay': {
                opacity: 1,
              },
            }}
          >
            <Box
              component="img"
              src={item.flyer_web}
              alt={item.titulo}
              sx={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            />
            <BotonInscribirme
              seleccionarEvento={seleccionarEvento}
              id_evento={item.id_evento}
            />
          </Box>

            <Box sx={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
            <Typography
              variant="h4"
              sx={{
                cursor: 'pointer',
                '&:hover': {
                  fontWeight: 'bold',
                },
              }}
              onClick={() => seleccionarEvento(item.id_evento)}
            >
              {item.titulo}
            </Typography>
              <Box sx={{m:2}}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <EventIcon style={{ marginRight: '8px', color: '#1976d2' }} />
                                <Typography variant="subtitle1" style={{ lineHeight: 1.2, fontWeight: 300,textAlign:'left' }}>{item?.descripcion}</Typography>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center',marginTop:'0.5rem'}}>
                                <LocationOnIcon style={{ marginRight: '8px', color: '#1976d2' }} />
                                <Typography variant="subtitle1" style={{ lineHeight: 1.2, fontWeight: 300,textAlign:'left' }}>{item?.detalles}</Typography>
                            </div>
                        </Box>
          </Box>
        </Box>
      </Grid>
    ))}
  </Grid>
</Box>
    return  <Box sx={{ p: { xs: 2, md: 8 },
                        background:'blue',
                        backgroundColor:'white',
                        width:'100%',
                        justifyContent:eventos.length === 1 ? 'center' : 'flex-start'}}>
    <Grid style={{background:'orange',backgroundColor:'white'}} container spacing={2}  >
      {eventos.map((item) => (
        <Grid item xs={12}
           md={eventos.length === 1 ? 6 : 6}
            key={item.id}>
          <Box
            sx={{
              borderRadius: 2,
              overflow: 'hidden',
              boxShadow: 2,
            }}
          >
                <Box
                sx={{
                    width: '100%',
                    p:2,
                    aspectRatio: '2 / 1',
                    overflow: 'hidden',
                    position: 'relative',
                    '&:hover .overlay': {
                    opacity: 1,
                    },
                }}
                >
                <Box
                    component="img"
                    src={item.flyer_web}
                    alt={item.titulo}
                    sx={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    }}
                />
                <BotonInscribirme seleccionarEvento={seleccionarEvento} id_evento={item.id_evento}/>

            </Box>

            <Box sx={{ p: 2 }}>
              <Typography variant="h5" sx={{
                cursor: 'pointer',
                '&:hover': {
                fontWeight: 'bold',
                },
                }}
                onClick={()=>seleccionarEvento(item.id_evento)}
                >
                {item.titulo}
            </Typography>
            <Typography  variant="subtitle1">{item.descripcion}</Typography>
            </Box>
          </Box>
        </Grid>
      ))}
    </Grid>
    </Box>
}

const BotonInscribirme = ({seleccionarEvento,id_evento})=>{
    return(      
    <Box
        className="overlay"
        sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        bgcolor: 'rgba(0, 0, 0, 0.4)', 
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: 0,
        transition: 'opacity 0.3s ease',
        }}
    >
        <Button onClick={(()=>seleccionarEvento(id_evento))} variant="contained" color="primary">
            Inscribirme
        </Button>
    </Box>)
}